import { useEffect, useCallback, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

function AppVersionLayout() {
  const location = useLocation();
  const [appVersion, setAppVersion] = useState(null);

  const fetchAppVersion = useCallback(async () => {
    const appVersionUrl = '/versions.json';
    try {
      const response = await fetch(`${appVersionUrl}?_ts=${Date.now()}`, {
        cache: 'no-store',
      });
      if (response?.ok) {
        const body = await response.json();
        return body?.packages;
      }
      return null;
    } catch (error) {
      return null;
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchAppVersion().then(packages => {
      if (cancelled || packages === null) return;

      if (appVersion === null) {
        setAppVersion(packages);
        return;
      }

      // If the app version has changed, hard reload the page
      if (JSON.stringify(appVersion) !== JSON.stringify(packages)) {
        setAppVersion(packages);
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('_ts', String(Date.now()));
        window.location.href = currentUrl.toString();
      }
    });
    return () => {
      cancelled = true;
    };
  }, [location.pathname, fetchAppVersion]);

  return <Outlet />;
}

export default AppVersionLayout;
